@if (store.temGuarnicao() && !expirada()) {
  <article class="rounded-pmdf-card bg-pmdf-surface shadow-pmdf-soft border border-pmdf-border-subtle p-3 flex flex-col gap-2">
    <!-- Cabeçalho compacto -->
    <button
      type="button"
      class="flex items-center justify-between gap-3 w-full text-left"
      (click)="abrirDialog()"
      aria-label="Ver ou editar guarnição"
    >
      <div class="flex items-center gap-2 min-w-0">
        <mat-icon class="icon-lg text-pmdf-primary shrink-0">groups</mat-icon>
        <span class="text-sm font-medium text-pmdf-text-primary truncate">
          @if (viaturaPrefixo()) {
            {{ viaturaPrefixo() }} &bull;
          }
          Guarnição
        </span>
        @if (origemGuarnicao() === 'ESCALA') {
          <nx-status-badge variant="success" label="Escala" [dot]="true" />
        }
      </div>
      <mat-icon class="icon-lg text-pmdf-muted-55 shrink-0">edit</mat-icon>
    </button>

    <!-- Lista de policiais -->
    @if (policiais().length > 0) {
      <div class="flex flex-col gap-1 pt-1 border-t border-pmdf-border-subtle">
        @for (pol of policiais(); track pol.matricula) {
          <div class="flex items-center gap-2 py-0.5 px-1">
            <span class="text-[10px] font-medium text-pmdf-primary bg-pmdf-primary/10 rounded px-1 py-px leading-tight shrink-0">
              {{ pol.postoGraduacao }}
            </span>
            <span class="text-xs text-pmdf-text-primary truncate flex-1">
              {{ pol.nome }}
            </span>
            @if (pol.funcao) {
              <span class="text-[10px] text-pmdf-muted-55 shrink-0">
                {{ funcaoLabel(pol.funcao) }}
              </span>
            }
          </div>
        }
      </div>
    }
  </article>
} @else if (store.temGuarnicao() && expirada()) {
  <button
    type="button"
    class="rounded-pmdf-card bg-pmdf-surface shadow-pmdf-soft border border-dashed border-pmdf-warning p-3 flex items-center justify-between gap-3 w-full text-left"
    (click)="abrirDialog()"
    aria-label="Guarnição expirada — clique para atualizar"
  >
    <div class="flex items-center gap-3">
      <mat-icon class="icon-base text-pmdf-warning shrink-0">groups</mat-icon>
      <div class="text-left">
        <p class="text-sm font-medium text-pmdf-text-primary">Guarnição expirada</p>
        <p class="text-xs text-pmdf-warning">Toque para atualizar sua guarnição</p>
      </div>
    </div>
    <mat-icon class="icon-sm text-pmdf-warning shrink-0">refresh</mat-icon>
  </button>
} @else {
  <button
    type="button"
    class="rounded-pmdf-card bg-pmdf-surface shadow-pmdf-soft border border-dashed border-pmdf-border-subtle p-3 flex items-center justify-between gap-3 w-full text-left"
    (click)="abrirDialog()"
    aria-label="Cadastrar guarnição"
  >
    <div class="flex items-center gap-3">
      <mat-icon class="icon-base text-pmdf-muted-55 shrink-0">groups</mat-icon>
      <div class="text-left">
        <p class="text-sm font-medium text-pmdf-text-primary">Cadastre sua guarnição</p>
        <p class="text-xs text-pmdf-muted-55">Agiliza o preenchimento do RAP</p>
      </div>
    </div>
    <mat-icon class="icon-sm text-pmdf-primary shrink-0">arrow_forward</mat-icon>
  </button>
}
